import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import qs from "qs";
import Alert from "react-s-alert";



class AddModal extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            option: [],
            isButtonLoading: false,
            isLoading: false,
            score:""
        };
        
        this.handleToggle = this.handleToggle.bind(this);
        this.handleSubmitSoal = this.handleSubmitSoal.bind(this);
        this.handleChangeScore = this.handleChangeScore.bind(this);
    }

    handleSubmitSoal() {

        this.setState({ isButtonLoading: true });
        const url = '/ujian/soal/add';
        const qOption = JSON.stringify(this.state.option);

        let newState = {
            exam_id: this.props.detailExam,
            question_id: this.props.detailSoal.question_id,
            question_type: this.props.detailSoal.question_type,
            option_id: this.state.option_id,
            option_match_id: this.state.option_match_id,
            score: this.state.score
        };
        

        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

        .then(response => {
            const result = response.data;

            if (result.success) {
                Alert.success(result.message);
                this.setState({ isButtonLoading: false },() => {
                    this.props.toggleModal();
                });

            } else {
                if (Array.isArray(result.message)) {
                    result.message.map(item => {
                        Alert.error(item);
                        return true;
                    });
                } else {
                    Alert.error(result.message);
                }

                this.setState({ isButtonLoading: false });
            }
        })
        
        .catch(error => {
            console.log(error);
            this.setState({ isButtonLoading: false });
            Alert.error("Gagal terhubung ke server!");
        });
    }

    handleChangeScore(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleToggle() {
        this.props.toggleModal()
    }

    handleSubmit() {
        this.props.handleSubmit()
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.handleToggle} className="modal-primary">
                <ModalHeader toggle={this.handleToggle}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    {/*Form*/}
                    <div className="card">
                        <div className="card-header">{this.props.mode} Pertanyaan</div>
                            <div className="card-block">
                                {this.state.isLoading ? (
                                    "Memuat Data..."
                                ) : (
                                    <div className="form-horizontal animated fadeIn">
                                        <div className="col-md-12">
                                            <table className="tb table">
                                                <tr>
                                                    <td>
                                                        {this.props.detailSoal.question_pict !== true ?(
                                                        
                                                            <p><div dangerouslySetInnerHTML={{ __html: this.props.detailSoal.question_text }} />{}</p>
                                                        
                                                        ):this.props.detailSoal.question_pict !== null ?(
                                                            <div>
                                                                <p>{}<div dangerouslySetInnerHTML={{ __html: this.props.detailSoal.question_text }} /></p>
                                                                <img
                                                                    src={"data:"+this.props.detailSoal.question_type_pict+";base64,"+this.props.detailSoal.question_pict}
                                                                    className="img-thumbnail"
                                                                    style={{ width: "100px" }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                        ):""}
                                                    </td>
                                                </tr>
                                                {this.props.detailSoal.question_type == 'match' ? (
                                                    this.props.detailSoal.option.length > '0' ? this.props.detailSoal.option.map((item, i) => (
                                                        <div
                                                            className="checkbox"
                                                            style={{ marginBottom: 10 }}
                                                            key={`question-option-${i}`}
                                                        >
                                                            <div className="form-group row">
                                                                <label className="col-md-3 form-control-label">
                                                                    Jawaban :
                                                                </label>
                                                                <div className="col-md-9">
                                                                <p>
                                                                <input
                                                                    type="text"
                                                                    disabled="disabled"
                                                                    placeholder="Opsi Jawaban"
                                                                    style={{
                                                                        padding: "3px 7px",
                                                                        border: "1px solid #ccc",
                                                                        width: "50%"
                                                                    }}
                                                                    value={item.option_text}
                                                                />
                                                                <input
                                                                    name="this.state.option_id"
                                                                    type="hidden"
                                                                    value={item.option_id}
                                                                />
                                                                </p>
                                                                <input
                                                                    type="text"
                                                                    disabled="disabled"
                                                                    placeholder="Opsi Jawaban Pasangan"
                                                                    style={{
                                                                        padding: "3px 7px",
                                                                        border: "1px solid #ccc",
                                                                        width: "50%"
                                                                    }}
                                                                    value={item.option_match_text}
                                                                />
                                                                
                                                                </div>
                                                            </div>
                                                        </div>
                                                        )):
                                                        <div className="form-group row">
                                                            <div className="col-md-12" style={{ textAlign:'center', margin:'10px' }}>
                                                                <strong><blockquote>Belum Ada Jawaban</blockquote></strong>
                                                            </div>
                                                        </div>
                                                ):""}
                                                {this.props.detailSoal.question_type == 'single' || this.props.detailSoal.question_type == 'multi' ? (
                                                    this.props.detailSoal.option.length > '0' ?
                                                        this.props.detailSoal.option.map((item, i) => (
                                                            <div
                                                                className="checkbox"
                                                                style={{ marginBottom: 10 }}
                                                                key={`question-option-${i}`}
                                                            >
                                                            {item.option_pict !== true ?(
                                                                <div className="form-group row">
                                                                    <label className="col-md-3 form-control-label">
                                                                        Jawaban :
                                                                    </label>
                                                                    <div className="col-md-9">
                                                                        <p>{}<div dangerouslySetInnerHTML={{ __html: item.option_text }} /></p>
                                                                        <input
                                                                            name="this.state.option_id"
                                                                            type="hidden"
                                                                            value={item.option_id}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ):
                                                            item.option_pict !== null ?(
                                                                <div className="form-group row">
                                                                    <label className="col-md-3 form-control-label">
                                                                        Jawaban :
                                                                    </label>
                                                                    <div className="col-md-9">
                                                                        <img
                                                                            src={"data:"+item.type_pict+";base64,"+item.option_pict}
                                                                            className="img-thumbnail"
                                                                            style={{ width: "100px" }}
                                                                            alt=""
                                                                        />
                                                                        <input
                                                                            name="this.state.option_id"
                                                                            type="hidden"
                                                                            value={item.option_id}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ):""}
                                                        </div>
                                                        )) :
                                                        <div className="form-group row">
                                                            <div className="col-md-12" style={{ textAlign:'center', margin:'10px' }}>
                                                                <strong><blockquote>Belum Ada Jawaban</blockquote></strong>
                                                            </div>
                                                        </div>

                                                ):""}
                                                    <div>
                                                        <div className="form-group row">
                                                            <label className="col-md-3 form-control-label">
                                                                Score :
                                                            </label>
                                                            <div className="col-md-9">
                                                                <input
                                                                    name="score"
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Score"
                                                                    onChange={this.handleChangeScore}
                                                                    value={this.state.score}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.isButtonLoading && "disabled"}  onClick={this.handleSubmitSoal}>{this.state.isButtonLoading ? "Loading" : "Simpan"}</Button>{' '}
                    <Button color="secondary" onClick={this.handleToggle}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

AddModal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    detailSoal: PropTypes.func.isRequired,
    detailExam: PropTypes.func.isRequired
} 

export default AddModal


// WEBPACK FOOTER //
// ./src/components/AddModal.js